import React, { useState } from 'react';
import BasicInformationForm from '../../../../components/forms/BasicInformationForm/Index';
import ContactInformationForm from '../../../../components/forms/ContactInformationForm/Index';
import LocationForm from '../../../../components/forms/LocationForm/Index';

export default function CombinedInformationSection({ values, errors, touched, handleChange, setFieldValue, setFieldError, stateRef }) {
  const [nameCheckStatus, setNameCheckStatus] = useState({
    loading: false,
    available: null,
    message: ''
  });

  const handleNameChange = async (e, form) => {
    const name = e.target.value;
    form.setFieldValue('shopName', name);
    
    if (name && name.length > 2) {
      try {
        setNameCheckStatus(prev => ({ ...prev, loading: true }));
        // Simulate name availability check
        // Replace this with your actual API call
        const isAvailable = true; // Replace with actual check
        
        setNameCheckStatus({
          loading: false,
          available: isAvailable,
          message: isAvailable ? 'Name is available!' : 'This name is already taken.'
        });
      } catch (error) {
        console.error('Error checking name availability:', error);
        setNameCheckStatus({
          loading: false,
          available: null,
          message: 'Error checking name availability'
        });
      }
    } else {
      setNameCheckStatus({
        loading: false,
        available: null,
        message: ''
      });
    }
  };

  return (
    <div className="combined-info-section">
      <BasicInformationForm
        values={values}
        errors={errors}
        touched={touched}
        handleChange={handleChange}
        setFieldValue={setFieldValue}
        setFieldError={setFieldError}
        nameCheckStatus={nameCheckStatus}
        onNameChange={handleNameChange}
        isEditMode={true}
      />

      <ContactInformationForm
        values={values}
        errors={errors}
        touched={touched}
        handleChange={handleChange}
      />

      <LocationForm
        values={values}
        errors={errors}
        touched={touched}
        handleChange={handleChange}
        setFieldValue={setFieldValue}
        stateRef={stateRef}
      />
    </div>
  );
}
